import { createFileRoute } from '@tanstack/react-router';
import { Navbar } from '@/components/sections/navbar';
import { SiteFooter } from '@/components/sections/site-footer';
import { CalculatriceAMG } from '@/components/sections/calculatrice-amg';

export function CalculatricePage() {
  return (
    <div className="flex min-h-[100dvh] flex-col bg-background text-foreground">
      <Navbar />
      <main className="flex-grow">
        <CalculatriceAMG />
      </main>
      <SiteFooter />
    </div>
  );
}

export const Route = createFileRoute('/calculatrice')({
  component: CalculatricePage
});
